import { FC } from 'react'
import CN from 'classnames'

export interface LoaderProps {
  className?: string | undefined
  isCustomStyles?: boolean | undefined
  size?: 'md' | 'lg'
  appearance?:
    | 'default'
    | 'secondary'
    | 'success'
    | 'warning'
    | 'error'
    | undefined
  [x: string]: any
}

export const Loader: FC<LoaderProps> = ({
  className,
  isCustomStyles,
  size,
  appearance,
}: LoaderProps) => {
  const LoaderClasses = !isCustomStyles
    ? CN('rounded-full', className, {
        'Loader h-1.5 w-1.5 ': size === 'md',
        'Loader h-2.5 w-2.5 ': size === 'lg',
        'Loader bg-white': appearance === 'default',
        'Loader bg-N-300': appearance === 'secondary',
        'Loader bg-G-500': appearance === 'success',
        'Loader bg-Y-500': appearance === 'warning',
        'Loader bg-R-500': appearance === 'error',
      })
    : className

  return (
    <div className='flex items-center justify-center z-20'>
      <div className={`${LoaderClasses} mr-1 animate-bounce200`}></div>
      <div className={`${LoaderClasses} mr-1 animate-bounce400`}></div>
      <div className={`${LoaderClasses} animate-bounce600`}></div>
    </div>
  )
}

Loader.defaultProps = {
  className: undefined,
  appearance: 'default',
  size: 'lg',
}

export default Loader
